import React, { useId } from 'react'
import PropTypes from 'prop-types'

const Minimize2Icon = React.forwardRef(function Minimize2Icon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 15.5C1 14.9477 1.44772 14.5 2 14.5H4C6.76228 14.5 9 16.7377 9 19.5V21.5C9 22.0523 8.55228 22.5 8 22.5 7.44772 22.5 7 22.0523 7 21.5V19.5C7 17.8423 5.65772 16.5 4 16.5H2C1.44772 16.5 1 16.0523 1 15.5ZM20 16.5C18.3423 16.5 17 17.8423 17 19.5V21.5C17 22.0523 16.5523 22.5 16 22.5 15.4477 22.5 15 22.0523 15 21.5V19.5C15 16.7377 17.2377 14.5 20 14.5H22C22.5523 14.5 23 14.9477 23 15.5 23 16.0523 22.5523 16.5 22 16.5H20ZM16 1.5C16.5523 1.5 17 1.94772 17 2.5V4.5C17 6.15772 18.3423 7.5 20 7.5H22C22.5523 7.5 23 7.94772 23 8.5 23 9.05228 22.5523 9.5 22 9.5H20C17.2377 9.5 15 7.26228 15 4.5V2.5C15 1.94772 15.4477 1.5 16 1.5ZM8 1.5C8.55228 1.5 9 1.94772 9 2.5V4.5C9 7.26228 6.76228 9.5 4 9.5H2C1.44772 9.5 1 9.05228 1 8.5 1 7.94772 1.44772 7.5 2 7.5H4C5.65772 7.5 7 6.15772 7 4.5V2.5C7 1.94772 7.44772 1.5 8 1.5Z"
      ></path>
    </svg>
  )
})

Minimize2Icon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

Minimize2Icon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default Minimize2Icon
